export default __webpack_public_path__ + "static/media/POML.4e05f987.png";